import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  notifications: [],
  loading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    clearNotificationsError: (state) => {
      state.error = null;
    },
    setNotificationsLoading: (state, action) => {
      state.loading = action.payload;
    },
    
    // Notification functions - regular reducers like other functions
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    
    updateNotification: (state, action) => {
      const { content, heading, metadata } = action.payload.data;

      const newNotification = {
        content: content,
        heading: heading,
        metadata: metadata,
        creationDate: dayjs().valueOf(),
      };
      state.notifications.unshift(newNotification);
    },
    
    updateUnreadNotification: (state, action) => {
      const { message } = action.payload.data;
      if (message === "success") {
        state.notifications = state.notifications.map((notification) => ({
          ...notification,
          isRead: true,
        }));
      }
    },
  },
});

export const { 
  clearNotificationsError, 
  setNotificationsLoading,
  setNotifications,
  updateNotification,
  updateUnreadNotification,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;

// Selectors
export const selectNotifications = (state) => state.notifications.notifications;
export const selectNotificationsLoading = (state) => state.notifications.loading;
export const selectNotificationsError = (state) => state.notifications.error;
